import React from 'react'
import OneProductDiscountContainer from '../../../../../Components/DiscountPart/DiscountListsContainer/OneProductDiscountContainer/OneProductDiscountContainer'
import Layout from '../../../Layout'

const OneProductDiscountList = () => {
  return (
    <Layout><OneProductDiscountContainer/></Layout>
  )
}

export default OneProductDiscountList